import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './FilterHeader.module.scss';

const FilterHeader = ({ title, className = null, subtitle = [] }) => {
  const subtitleContent = Array.isArray(subtitle) ? subtitle : [subtitle];
  const filteredSubtitleContent = subtitleContent.filter(Boolean);
  const classes = classNames(styles['filter-header'], className);
  return (
    <div className={classes}>
      <h2>{title}</h2>
      {filteredSubtitleContent?.length
        ? filteredSubtitleContent.map(item => <p key={item}>{item}</p>)
        : null}
    </div>
  );
};

FilterHeader.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
};

export default FilterHeader;
